import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import Raven from 'raven-js';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { alertFailure, alertSuccess } from '../../alerts/alerts';
import { GenericSkeleton } from '../../components/GenericSkeleton';
import { useFetchSingleView } from '../../singleView/hooks/useFetchSingleView';
import { trackDeleteView } from '../../tracking/viewsManagementTracking';
import { useUserId } from '../../userInfo/hooks/useUserId';
import { useCanUserDeleteView } from '../hooks/useCanUserDeleteView';
import { useDeleteSingleView } from '../hooks/useDeleteSingleView';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const doSuccessAlert = viewName => alertSuccess({
  message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "viewsManagement.modals.deleteSingleView.alert.success.message",
    options: {
      viewName
    }
  })
});
export const doFailureAlert = () => alertFailure({
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "viewsManagement.modals.deleteSingleView.alert.failure.title"
  })
});
export const DeleteSingleViewModal = ({
  viewId,
  objectTypeId,
  namespaceName,
  onClose
}) => {
  const userId = useUserId();
  const {
    data,
    loading,
    error
  } = useFetchSingleView({
    id: viewId,
    objectTypeId,
    namespaceName
  });
  const [canDelete, permissionExplanation, alertLevel] = useCanUserDeleteView({
    view: data && data.singleViewById
  });
  const [doDelete, {
    error: deleteError,
    loading: deleteLoading
  }] = useDeleteSingleView({
    viewId,
    objectTypeId
  });
  const handleConfirm = useCallback(() => {
    if (data) {
      doDelete().then(() => {
        doSuccessAlert(data.singleViewById.name);
        onClose(true);
        trackDeleteView();
      }).catch(e => {
        doFailureAlert();
        Raven.captureException(e, {
          extra: {
            isDelete: true,
            viewObject: data
          }
        });
      });
    }
  }, [onClose, doDelete, data]);
  if (userId === null) {
    return /*#__PURE__*/_jsx(GenericSkeleton, {});
  }
  return /*#__PURE__*/_jsx(ConfirmModal, {
    "data-test-loading": loading || deleteLoading,
    "data-test-id": "delete-single-view-modal",
    confirmUse: "danger",
    size: "auto",
    use: "danger",
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "viewsManagement.modals.deleteSingleView.title"
    }),
    description: /*#__PURE__*/_jsxs(_Fragment, {
      children: [loading && !data && /*#__PURE__*/_jsx(GenericSkeleton, {}), data && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "viewsManagement.modals.deleteSingleView.body",
        options: {
          viewName: data.singleViewById.name
        }
      }), permissionExplanation && alertLevel ? /*#__PURE__*/_jsx(Alert, {
        type: alertLevel,
        children: permissionExplanation
      }) : permissionExplanation, error && /*#__PURE__*/_jsx(Alert, {
        type: "danger",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "viewsManagement.modals.deleteSingleView.errors.fetchError"
        })
      }), deleteError && /*#__PURE__*/_jsx(Alert, {
        type: "danger",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "viewsManagement.modals.deleteSingleView.errors.deleteError"
        })
      })]
    }),
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "viewsManagement.modals.deleteSingleView.confirm"
    }),
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "viewsManagement.modals.deleteSingleView.reject"
    }),
    confirmButtonProps: {
      'data-test-id': 'delete-single-view-modal-confirm',
      disabled: Boolean(!canDelete || error),
      loading: deleteLoading,
      failed: Boolean(deleteError)
    },
    ConfirmButton: LoadingButton,
    onConfirm: handleConfirm,
    onReject: onClose
  });
};